export const SummaryHeaderConstants = {
  MAX_VISIBLE_ITEMS: 11,
  TOTAL_QUARRY_LABEL: "Total Quarrys",
  OTHERS_LABEL: "Others",
};

export const getGridColumnCount = (count: number): number => {
  if (count <= 3) return 3;
  if (count === 4) return 2;
  if (count <= 6) return 3;
  if (count <= 8) return 4;
  if (count <= 10) return 5;
  if (count <= 12) return 6;
  return 6;
};

export const data = {
  message: "Success",
  data: {
    total: 14,
    categories: {
      Granite: 2,
      Limestone: 13,
      Disposal: 2,
      Sand: 1,
      "River Rock": 4,
      "Crushed Concrete": 1,
      Asphalt: 1,
      "Hat Rock": 1,
      Gravel: 7,
      Topsoil: 5,
      "Fill Dirt": 8,
      Mulch: 3,
      Flagstone: 6,
      "Paving Stones": 9,
      "Decomposed Granite": 11,
      Slate: 10,
      Basalt: 1,
      "Tumbled Stone": 2,
      Brick: 5,
      Aggregate: 12,
      "Recycled Asphalt": 4,
      Cobblestone: 7,
      "Washed Stone": 3,
      Boulders: 6,
    },
  },
};
